/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { Notify } from "notiflix/build/notiflix-notify-aio";
import { Confirm } from "notiflix/build/notiflix-confirm-aio";

import { styled } from "@mui/material/styles";

import moment from "moment";

import { Loading } from "notiflix/build/notiflix-loading-aio";
import { Block } from "notiflix/build/notiflix-block-aio";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";

import TextField from "@mui/material/TextField";

import Box from "@mui/material/Box";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { AddBox } from "@mui/icons-material";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Typography from "@mui/material/Typography";

import ControlledTextInput from "components/FormInputs/ControlledTextInput";
import ControlledDateTime from "components/FormInputs/ControlledDateTime";
import ControlledCheckbox from "components/FormInputs/ControlledCheckbox";
import ControlledSelect from "components/FormInputs/ControlledSelect";
import CustomInputs from "components/CustomInputs";
import { CustomSelect } from "components/CustomSelect";

//components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import MDBadge from "components/MDBadge";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";

import Check from "@mui/icons-material/Check";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from '@mui/material/FormControlLabel';

import Tooltip from "@mui/material/Tooltip";

import Edit from "@mui/icons-material/Edit";
import Close from "@mui/icons-material/Close";
import SettingsIcon from '@mui/icons-material/Settings';

import InputAdornment from "@mui/material/InputAdornment";

import Alert from "components/CustomAlert";

import ViewReminder from './view'

import { tables, dateTimeFormat, dateFormat } from "utils/constants";

// rtk queries
import {
  useGetAllReminderTypesQuery,
  useLazyGetAllReminderTypesQuery,
  useDeleteReminderTypeMutation,
  useGetAllPastRemindersQuery
} from "services/reminders";

import { globalCountry } from "store/entities/countries";

import { replaceHTMLEntityAnd } from "utils/helperFunctions";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function ReminderHistory () {

  const selectedCountry = useSelector(globalCountry);

  const { data: reminderTypes, isLoading: isReminderTypesLoading, isSuccess: isReminderTypesSuccess } = useGetAllReminderTypesQuery();
  
  const { data: pastReminders = [], isLoading, isSuccess } = useGetAllPastRemindersQuery();

  const dispatch = useDispatch();

  useEffect(() => {
    Loading.dots({
      svgColor: "rgba(159, 3, 3, 0.8)",
    });

    isSuccess && isReminderTypesSuccess && Loading.remove(500);
  }, [isSuccess, isReminderTypesSuccess]);

  const tableData = useMemo(() => {
    let filteredReminders = [];
    if(pastReminders && pastReminders.length > 0) {
      filteredReminders = pastReminders.map(reminder => {
        return {
          custom_reminder: reminder.custom_reminder,
          custom_reminder_id: reminder.custom_reminder_id,
          digital_key_end_users: reminder.digital_key_end_users,
          end_user_id: reminder.end_user_id,
          id: reminder.id,
          product_id: reminder.product_id,
          products: reminder.products,
          reminder_type_id: reminder.reminder_type_id,
          reseller: reminder.reseller,
          reseller_id: reminder.reseller_id,
          subscription_expiry_date: reminder.subscription_expiry_date,
          triggered_time: reminder.triggered_time,
          product_name: (reminder.products && reminder.products.name) ? reminder.products.name : (reminder.end_user_id && reminder.digital_key_end_users && reminder.digital_key_end_users.digital_keys && reminder.digital_key_end_users.digital_keys.products && reminder.digital_key_end_users.digital_keys.products.name) ? reminder.digital_key_end_users.digital_keys.products.name : 'N/A',
          reseller_email: (reminder.reseller && reminder.reseller.email) ? reminder.reseller.email : (reminder.end_user_id && reminder.digital_key_end_users && reminder.digital_key_end_users.digital_keys && reminder.digital_key_end_users.digital_keys.orders && reminder.digital_key_end_users.digital_keys.orders.reseller) ? reminder.digital_key_end_users.digital_keys.orders.reseller.email : 'N/A'
        }
      })
    }
    return filteredReminders;
  }, [pastReminders])

  return (
    <Card>
      <CardHeader
        // avatar={<AccountCircleIcon fontSize="large" color="info" />}
        title={<MDTypography color="info">Reminder History</MDTypography>}
      />
      <CardContent>
        <br />
        {/* {BDMList && BDMList.length > 0 ? ( */}
          <DataTable
            // headerActions={
            //   <FormControlLabel control={
            //     <Checkbox
            //     checkedIcon={<Check />}
            //     icon={<Check />}
            //     onChange={(e) => setWithOldRecords(e.target.checked)}
            //     checked={withOldRecords}
            //   />
            //   } label="Including inactive" />
            // }
            columns={[
              { 
                Header: "id", 
                accessor: "id",
              },
              { 
                Header: "product", 
                accessor: "product_id",
                Cell: ({ row: { original } }) => (original.products && original.products.name) ? original.products.name : (original.end_user_id && original.digital_key_end_users && original.digital_key_end_users.digital_keys && original.digital_key_end_users.digital_keys.products && original.digital_key_end_users.digital_keys.products.name) ? original.digital_key_end_users.digital_keys.products.name : 'N/A'
              },
              { 
                Header: "reseller", 
                accessor: "reseller",
                Cell: ({ row: { original } }) => (original.reseller && original.reseller.email) ? original.reseller.email : (original.end_user_id && original.digital_key_end_users && original.digital_key_end_users.digital_keys && original.digital_key_end_users.digital_keys.orders && original.digital_key_end_users.digital_keys.orders.reseller) ? original.digital_key_end_users.digital_keys.orders.reseller.email : 'N/A'
              },
              { 
                Header: "Type", 
                accessor: "is_custom",
                // Cell: ({ row: { original } }) => {selectedCountry.currency + original.total_sales.toFixed(2)}
                Cell: ({ row: { original } }) => original.custom_reminder_id ? <MDBadge badgeContent="Custom" color="success" variant="gradient" size="sm" /> : original.end_user_id ? <MDBadge badgeContent="End-User reminder" color="info" variant="gradient" size="sm" /> : <MDBadge badgeContent="Class A" color="primary" variant="gradient" size="sm" />
              },
              {
                Header: "Expiry Date",
                accessor: "subscription_expiry_date",
                Cell: ({ row: { original } }) => moment(original.subscription_expiry_date).format(dateFormat),
              },
              {
                Header: "Triggered Time",
                accessor: "triggered_time",
                Cell: ({ row: { original } }) => moment(original.triggered_time).format(dateTimeFormat),
              },
              {
                Header: "action",
                accessor: "action",
                align: "right",
                disableSortBy: true,
                disableFilters: true,
                show: true,
                // eslint-disable-next-line react/display-name
                Cell: ({ row: { original } }) => (
                  <div className="actions-right">
                    <ViewReminder data={original} reminderTypes={reminderTypes} country={selectedCountry} />
                  </div>
                ),
              },
            ]}
            data={tableData}
            isSorted={true}
            entriesPerPage={false}
            showTotalEntries={false}
            hideColumnSelection={false}
            noEndBorder
            canSearch
            // actionButton={
            //   <AddCustomReminder country={selectedCountry.id} />
            // }
          />
        {/* ) : (
          <Alert severity="warning">No Business Developement Managers found!</Alert>
        )} */}
      </CardContent>
    </Card>
  );
}

export default ReminderHistory;
